import React, { useState } from 'react'
import Col from 'react-bootstrap/esm/Col'
import Container from 'react-bootstrap/esm/Container'
import { Link } from "react-router-dom";
import Row from 'react-bootstrap/esm/Row'
import i1 from '../assets/intro.webp'
// import video1 from '../assets/Work/Soly Systems/Balance Out your Energy Use.mp4'
import {
 
  FaGithub,
  FaLinkedin,
  FaMailBulk,
  FaSlack,
  FaStar,
 
} from "react-icons/fa";
import { Nav } from 'react-bootstrap'
const Intro = () => {
  const iconStyle={
    // backgroundColor: "var(--secondary)",
              fontSize: "20px",
              fontWeight: "800",
              color: "var(--secondary)",
              border: "2px solid var(--secondary)",
              borderRadius:"20%",
              margin:"0 1px",
              padding:"8px 10px"
             
  }
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  const handleNavLinkClick = () => {
    console.log("Before:", expanded);
    setExpanded(false);
    console.log("After:", expanded);
  };
  return (
      <Container  >
      <Row className="align-items-center" style={{ justifyContent: 'space-between',paddingTop:"4rem" }}>
        <Col lg={6} md={6} sm={6} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <Row>
            <h4 style={{ fontFamily: "Cookie",textAlign:"left",fontWeight:"400",fontSize:"2.6rem",textAlign:"left",color:"var(--secondary)"}}> Hey, I'm Kashaf Abdullah</h4>
          <p className='text'>

          Passionate web developer with a flair for design and a knack for problem-solving, dedicated to crafting exceptional digital experiences.  </p>

          <h4  style={{textAlign:"left",fontWeight:"500",fontSize:"1.4rem",color:"var(--textcolor)"}}>Experienced website developer crafting innovative, user-friendly digital solutions.!</h4>
<p className='text'>
I have honed my skills through diverse experiences, including internships and professional roles, where I tackled a wide range of challenges in the world of web development. These opportunities have allowed me to deepen my expertise, particularly in front-end and back-end technologies, ensuring that I deliver not just functional, but also aesthetically pleasing and intuitive user interfaces
</p>

<div className="logo-social-media" style={{ margin: "1rem 0" }}>
        
<a className='button-85' href="https://www.linkedin.com/in/kashaf-abdullah-482246207/" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
      <FaLinkedin style={{position:"relative",bottom:"2px"}}/>
    </a>

    <a className='button-85' href="https://github.com/Kashaf-Abdullah/" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
      <FaGithub style={{position:"relative",bottom:"2px"}}/>
    </a>

    <a className='button-85' href="mailto: kashafabdullah01@gmail.com" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
      <FaMailBulk style={{position:"relative",bottom:"2px"}}/>
    </a>


    <a className='button-85' href="" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
      <FaSlack style={{position:"relative",bottom:"2px"}}/>
    </a>
  
         </div>
       
            </Row>
        </Col>
        <Col lg={6} md={6} sm={6} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' ,color:"var(--white)"}}>

      
          <div className="circle">
            <img
              src={i1}
              alt="description"
              className="img-fluid"
            />
          </div>
        </Col>
        </Row>
      </Container>
 
  )
}

export default Intro
